import axios from "axios";
import { LOGIN_API_URL } from "../constants";

export const authenticateWithGoogle = async ({ accessToken, idToken }) => {
  const response = await axios.post(
    `${LOGIN_API_URL}/oauth2/google-auth`,
    {
      access_token: accessToken,
      id_token: idToken,
    },
    {
      withCredentials: true,
    }
  );

  return response.data;
};
